import * as React from 'react';
import * as numeral from 'numeral';

import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';

export interface GalleryHeaderProps {
    tokenCountRetriever: () => Promise<number>;
}

export interface GalleryHeaderState {
  counter: number;
}

export default class GalleryHeader extends React.Component<GalleryHeaderProps, GalleryHeaderState> {
  constructor(props: GalleryHeaderProps) {
    super(props);

    this.state = {
      counter: 0
    }
  }


  public componentDidMount(){
    this.props.tokenCountRetriever().then(result => {
      this.setState({counter: result})
    })
  }

  public render() {
    return (
      <div className="gallery-header">
          <Fade left>
            <hr/>
          </Fade>
          <Fade right>
            <h1 className="gallery-name">
                Explore Encrypto Art
            </h1>
          </Fade>
          <Fade bottom>
            <h4 className="token-count">{numeral(this.state.counter).format('0,0')} tokens</h4>
          </Fade>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/gallery-header.tsx